import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  operationGroups: [],
  operationGroup: null,
};

export default {
  namespaced: true,
  name: "operationGroups",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_OPERATION_GROUPS](state, payload = []) {
      state.operationGroups = payload;
    },
    [actions.GET_OPERATION_GROUP](state, payload = null) {
      state.operationGroup = payload;
    },
    [actions.CREATE_OPERATION_GROUP](state, payload = null) {
      state.operationGroup = payload;
    },
    [actions.UPDATE_OPERATION_GROUP](state, payload = null) {
      state.operationGroup = payload;
    },
    [actions.RESET_OPERATION_GROUP_FORM](state) {
      state.operationGroup = null;
    },
  },
  actions: {
    async fetchOperationGroups({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.operationGroups.base,
            "GET",
            null,
            payload
          );
          commit(actions.GET_OPERATION_GROUPS, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_OPERATION_GROUPS, []);
          reject(error);
        }
      });
    },
    async fetchOperationGroup({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.admin.operationGroups.single(payload),
            "GET"
          );
          commit(actions.GET_OPERATION_GROUP, data);
          resolve(data);
        } catch (error) {
          commit(actions.GET_OPERATION_GROUP, null);
          reject(error);
        }
      });
    },
    async createOperationGroup({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.operationGroups.base,
            "POST",
            payload
          );
          commit(actions.CREATE_OPERATION_GROUP, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async updateOperationGroup({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.operationGroups.single(payload.id),
            "PUT",
            payload
          );
          commit(actions.UPDATE_OPERATION_GROUP, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteOperationGroup(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.operationGroups.single(payload),
            "DELETE"
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async syncMembers(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.operationGroups.syncMembers(payload.id),
            "POST",
            { user_ids: payload.user_ids }
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetForm({ commit }) {
      commit(actions.RESET_OPERATION_GROUP_FORM);
    },
  },
};
